/**
 * Обмеження ширини сторінки — ЗНЯТЕ для всіх акаунтів (було лише для ArtemK).
 *
 * Сторінки кабінету мали `max-w-[1400px]` / `max-w-[1440px]`: на екрані ширше
 * за ~1700px (з рейкою сайдбара) контент ставав колонкою зліва, а праворуч
 * лишалось порожнє поле — плитки «не ресайзились». Для ArtemK головна вже без
 * ліміту, тож і розділи «Фінанси», «Контакти», «Інфо» та ряд кнопок над ними
 * тягнуться на всю доступну ширину, як і Головна.
 *
 * Тепер так само для всіх акаунтів, окремі групи не розрізняються.
 *
 * Класи — ПОВНІ літерали (а не 'max-w-[' + n + 'px]'): Tailwind збирає лише
 * те, що бачить у вихідному коді як цілий рядок.
 */

export function pageMaxClass(cap: 1400 | 1440): string {
  // Ліміт знято для ВСІХ акаунтів (14–15.10): контент тягнеться на всю ширину,
  // як у ArtemK. Параметр cap лишено, щоб не чіпати виклики на сторінках.
  void cap;
  return '';
}
